const initialState = {
    items: [],
    select: []
};

export default (state = initialState, action) => {
    switch (action.type) {
        case 'GET_GLOBALS':
            const select = [];
            let items = [];

            if (action.payload.fieldDefinitions){
                action.payload.fieldDefinitions.forEach((fieldDefinition) => {
                    select.push({
                        id: fieldDefinition.id,
                        title: fieldDefinition.key
                    });
                });
                items = action.payload.fieldDefinitions;
            }
            
            return {
                ...state,
                items: items,
                select: select
            };
            
        default:
            return state;
    }
};


// WEBPACK FOOTER //
// ./src/core/store/reducers/fielddefinition.js